<template>
  <!-- Page Content -->
  <div id='page-wrapper'>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='row'>
        <div class='col-lg-12'>
          <h1 class='page-header'>مصادقة اليومية</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class='row'>
        <div class='col-lg-12'>
          <div class='panel panel-default'>
            <div class='panel-heading'>
            هنا يتم مصادقة اليومية مع العملاء
            </div>
            <!-- /.panel-heading -->
            <div class='panel-body'>
              <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='validationErrors'>
                <ul v-if='validationErrors'>
                  <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class='col-lg-3 col-md-3 col-sm-6' style="padding: 5px">
                <label>الفرع</label>
                <select  @change='UpdateData($event.target.value)' class="form-control" style="padding: 0px" v-model="branche_id">
                  <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                    {{ item.name }}
                  </option>
                </select>
              </div>
              <div class='col-lg-3 col-md-3 col-sm-6' style="padding: 5px">
                <tbDate :today='today' :mytitle='dateTitle' v-model= 'dayDate' ></tbDate>
              </div>
              <div class='col-lg-4 col-md-4 col-sm-6' style="padding: 5px">
                <label>المحصل:</label>
              <div class="form-group input-group">
                <span class="input-group-btn">
                  <vue-element-loading size='32' :active='isgetTec' spinner='spinner' color='#A4A4A4'/>
                    <button
                      @click="getTec()" class="btn btn-default" type="button"><i class="fa fa-search"></i>
                    </button>
                </span>
                <select class="form-control" style="padding: 0px" v-model="collector_id">
                  <option v-for="collector in collectors" v-bind:key="collector.id" v-bind:value="collector.id">
                    {{ collector.name }}
                  </option>
                </select>
                </div>
              </div>
              <div style="padding:29px 5px 5px 3px" class='col-lg-2 col-md-2 col-sm-6'>
                <button type='button'  @click='FillGrid()' class='btn btn-outline btn-primary btn-md btn-block ' >
                  <b> عرض </b>
                </button>
              </div>
              <br>
              <br>
              <br>
              <br>
              <div id="contentToPrint"  style="padding-top: 5px">
                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                  <thead>
                    <tr>
                      <th style='text-align: center'>م</th>
                      <th style='text-align: center'>الايصال</th>
                      <th style='text-align: center'>الاسم</th>
                      <th style='text-align: center'>الحالة</th>
                      <th style='text-align: center'>الاجراء</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr :class="{fcolorgreen :record.status_type == 4,deleted :record.status_type == 3,fcolor :record.status_type == 1 || record.status_type == 5}" class='odd gradeX' v-for='(record,index) in records' :key='index'>

                      <td align='center'>{{index +1 }}</td>
                      <td align='center'>{{record.id}}</td>
                      <td align='center'>{{record.name}}</td>
                      <td align='center'>{{record.type}}</td>
                      <td align='center'>
                        <button v-if="record.status_type == 2" @click='showForm(record)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal' >مصادقة</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.table-responsive -->
            </div>
            <!-- /.panel-body -->
          </div>
          <!-- /.panel -->
        </div>
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- Modal -->
    <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
      <div class='modal-dialog  modal-md'>
        <div class='modal-content'>
          <div class='modal-header'>
            <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
            <h4 class='modal-title' id='myModalLabel'>إضافة عملية جديدة</h4>
          </div>
          <form role='form'>
            <div class='modal-body'>
              <div class='alert alert-danger alert-dismissable' v-if='validationModelErrors'>
                <ul v-if='validationModelErrors'>
                  <li v-for='err in validationModelErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class='alert alert-success alert-dismissable' v-if='successShow'>
                {{success}}
              </div>
              <fieldset>
                <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='validationReceiptErrors'>
                  <ul v-if='validationReceiptErrors'>
                    <li v-for='err in validationReceiptErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                  </ul>
                </div>
                <div class="row" style="padding: 5px">
                  <div class='col-lg-4 col-md-4 col-sm-6' style="padding-left: 2px">
                    <label>التقييم</label>
                    <select style="padding: 0px" class="form-control"  v-model="record.evaluation">
                      <option v-for="item in evaluations" v-bind:key="item.id" v-bind:value="item.id">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <div class='col-lg-4 col-md-4 col-sm-6' style="padding-left: 2px">
                    <label>المصداقية</label>
                    <select style="padding: 0px" class="form-control"  v-model="record.credibility">
                      <option v-for="item in credibilitys" v-bind:key="item.id" v-bind:value="item.id">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <div class='col-lg-4 col-md-4 col-sm-6' style="padding-left: 2px">
                    <label>حالة المصادقة</label>
                    <select style="padding: 0px" class="form-control"  v-model="record.status">
                      <option v-for="item in status" v-bind:key="item.id" v-bind:value="item.id">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <div class='col-lg-12 col-md-12 col-sm-12' style="padding: 2px 2px 2px 10px">
                    <label>ملاحظات</label>
                    <input v-model='record.notes' class='form-control' name='name' type='text'>
                  </div>
                </div>
              </fieldset>
            </div>
            <div class='modal-footer'>
              <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
              <button @click='saveData()' type='button' class='btn btn-primary'>حفظ</button>
              <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
            </div>
          </form>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- /.container-fluid -->
  </div>
</template>
<style>
.fcolor {
   color: #FF0000;
}
.fcolorgreen {
   color: #0BB21A;
}
.deleted {
  text-decoration: line-through;
}
</style>
<style>
  .unselectable {
    -webkit-user-select: none;
    -webkit-touch-callout: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
</style>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  components: {
    tbDate
  },
  name: 'ReceiptAuthorization',
  data () {
    return {
      evaluations: [
        {id: 0, name: ''},
        {id: 1, name: 'ضعيف'},
        {id: 2, name: 'مقبول'},
        {id: 3, name: 'جيد'}
      ],
      credibilitys: [
        {id: 0, name: ''},
        {id: 1, name: 'مطابق'},
        {id: 2, name: 'غير مطابق'}
      ],
      status: [
        {id: 1, name: 'تم'},
        {id: 0, name: 'لم تتم'}
      ],
      isgetTec: false,
      branches: {},
      branche_id: '',
      collectors: {},
      collector_id: '',
      today: true,
      dateTitle: 'التاريخ',
      dayDate: '',
      successShow: '',
      validationErrors: '',
      validationModelErrors: '',
      validationReceiptErrors: '',
      records: {},
      record: {},
      isLoadingData: false,
      isLoadingSave: false
    }
  },
  created () {
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.branche_id = localStorage.getItem('BrancheID')
    this.UpdateData(this.branche_id)
  },
  methods: {
    UpdateData (id) {
      this.collectors = ''
    },
    // ========================================================
    getTec () {
      this.isgetTec = true
      axios.post(this.$apiURL + 'get-folder-tec', {
        token: localStorage.getItem('token'),
        branch_id: this.branche_id,
        folder_date: this.dayDate
      })
        .then(({ data }) => {
          this.collectors = data
          this.isgetTec = false
        })
        .catch(err => {
          if (err) {
            this.isgetTec = false
          }
        })
    },
    // ======================================================
    FillGrid () {
      this.records = ''
      this.isLoadingData = true
      this.validationErrors = ''
      this.errorShow = false
      axios.post(this.$apiURL + 'get-folder-receipts-authorization', {
        token: localStorage.getItem('token'),
        collector_id: this.collector_id,
        sort: 'cash_receipts.id',
        folder_date: this.dayDate
      })
        .then(({ data }) => {
          if (data.length > 0) {
            this.records = data
          }
          this.isLoadingData = false
          this.errorShow = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingData = false
        })
    },
    // ======================================================
    showForm (rec) {
      this.record = rec
    },
    // ============================================================
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveItemPrices', {
        token: localStorage.getItem('token'),
        id: this.record.receipt_authorization_id,
        cash_receipt_id: this.record.cash_receipt_id,
        credibility: this.record.credibility,
        evaluation: this.record.evaluation,
        status: this.record.status,
        notes: this.record.notes
      })
        .then(res => {
          this.isLoadingSave = false
          this.successShow = true
          this.errorShow = false
        })
        .catch(err => {
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Accounts/Daily/ReceiptAuthorization.vue